import Vue from 'vue';
import Vuex from 'vuex';

//dependencies
import router from './router';
import vuetify from './plugins/vuetify';
/*import ScrollLoader from 'vue-scroll-loader'*/
import VuePersianDatetimePicker from 'vue-persian-datetime-picker';
Vue.component('date-picker', VuePersianDatetimePicker);

import tinymce from 'vue-tinymce-editor'
Vue.component('tinymce', tinymce);

import { VueTags } from 'vue-tags-component';

Vue.component('vue-tags', VueTags);

Vue.use(Vuex);/*
Vue.use(ScrollLoader);*/

/*import SocialSharing from 'vue-social-sharing';
Vue.use(SocialSharing);*/

//filters
import "./vueFilters"

//static data
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import store from "./store"

//watch queue status
store.watch(store.state.get4watch.getQueueStatus, (queueStatus) => (queueStatus === 1 ? store.dispatch('callServer') : ''));
//watch alert list
store.watch(store.state.get4watch.getAlertList, () => store.dispatch('runAlert'));

// import section

import App from './App.vue'

new Vue({
    router,
    vuetify,
    store,
    render: h => h(App)
}).$mount('#app');


